// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-card-enter-active{-webkit-animation:fadeIn .3s;animation:fadeIn .3s}.modal-card-enter-active .modal-card{-webkit-animation:zoomIn .3s;animation:zoomIn .3s}.modal-card-leave-active{-webkit-animation:fadeOut .3s;animation:fadeOut .3s}.modal-card-leave-active .modal-card{-webkit-animation:zoomOut .3s;animation:zoomOut .3s}@media screen and (max-width: 768px){.modal-card{margin:0}}\n", ""]);
// Exports
module.exports = exports;
